const THEME_COLORS = ["dark", "light", "primary", "secondary"];

let scrollDirection = "down";

function resolveThemeColor(target) {
  const color = target?.dataset?.themeColor?.trim();
  return THEME_COLORS.includes(color) ? color : null;
}

function resolveSectionTheme(section) {
  const theme = section?.dataset?.theme?.trim();
  return THEME_COLORS.includes(theme) ? theme : "dark";
}

function isMorphSection(section) {
  const active = resolveThemeColor(section);
  const resting = resolveSectionTheme(section);
  return Boolean(active && resting && active !== resting);
}

function isMorphActive(section) {
  if (!isMorphSection(section)) return true;
  const color = resolveThemeColor(section);
  return Boolean(color && section.classList.contains(`theme-${color}`));
}

function applyBodyTheme(color) {
  if (!color || !THEME_COLORS.includes(color)) return;

  const header = document.querySelector(".site-header");

  THEME_COLORS.forEach((name) => {
    document.body.classList.remove(`theme-${name}`);
    header?.classList.remove(`theme-${name}`);
  });

  document.body.classList.add(`theme-${color}`);
  document.body.setAttribute("data-theme", color);
  header?.classList.add(`theme-${color}`);
  header?.setAttribute("data-theme", color);
}

function resolveHeaderTheme(section) {
  const activeColor = resolveThemeColor(section);
  const restingTheme = resolveSectionTheme(section);

  if (!activeColor) return restingTheme;
  if (isMorphSection(section) && !isMorphActive(section)) return restingTheme;
  return activeColor;
}

function syncHeaderThemeFromScroll() {
  if (document.body.classList.contains("menu-overlay-open")) return;

  const header = document.querySelector(".site-header");
  const probeY = (header?.getBoundingClientRect().bottom ?? 72) + 2;

  const sections = [...document.querySelectorAll(".content-wrapper[data-theme]")].filter((section) => {
    const rect = section.getBoundingClientRect();
    return rect.top <= probeY && rect.bottom > probeY;
  });

  if (!sections.length) return;

  let active = sections.at(-1);
  if (!isMorphActive(active)) {
    active = sections.at(-2) ?? active;
  }

  applyBodyTheme(resolveHeaderTheme(active));
}

export function initThemeChange(loco) {
  let lastY = loco?.lenisInstance?.scroll ?? window.scrollY ?? 0;

  const onScroll = () => {
    const y = loco?.lenisInstance?.scroll ?? window.scrollY ?? 0;
    if (y !== lastY) {
      scrollDirection = y > lastY ? "down" : "up";
      lastY = y;
    }
    syncHeaderThemeFromScroll();
  };

  window.addEventListener("themeChange", (event) => {
    const detail = event?.detail || {};
    const target = detail.target;
    const way = detail.way;
    const color = resolveThemeColor(target);
    if (!color || !way) return;

    if (way === "enter") {
      if (isMorphSection(target) && scrollDirection !== "down") {
        syncHeaderThemeFromScroll();
        return;
      }

      target.classList.add(`theme-${color}`);
      applyBodyTheme(color);
      return;
    }

    if (way === "leave") {
      target.classList.remove(`theme-${color}`);
      syncHeaderThemeFromScroll();
    }
  });

  if (typeof loco?.subscribeLenisScroll === "function") {
    loco.subscribeLenisScroll(onScroll);
  } else {
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  onScroll();
  requestAnimationFrame(onScroll);
}
